import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c0a06ef&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2c0a06ef&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a06ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0a06ef')) {
      api.createRecord('2c0a06ef', component.options)
    } else {
      api.reload('2c0a06ef', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2c0a06ef&scoped=true", function () {
      api.rerender('2c0a06ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplierManagement/requestMessageList/index.vue"
export default component.exports